import React, { useEffect, useState, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import { InputText, SecondaryButton, MandatoryField, SimpleField } from '../../../Core/Controls';
import { AppContext } from '../../../Core/App/PageLevel/AppContextProvider';
import { getVORLoggedBy, postVORLoggedBy } from '../../../Core/Services/InternalUser/VOR/vorLoggedByService';
import { SketchPicker } from 'react-color';
import FormLabel from '@material-ui/core/FormLabel';
import { CircularProgress, Typography } from '@material-ui/core';

function VorLoggedByModal(props) {
    const { toastState } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [btnLoader, setBtnLoader] = useState(false);
    const [state, setState] = useState({
        vORLoggedByDescription: '',
        vORLoggedByBackgroundColour: '#ffffff',
        vORLoggedByTextColour: '#000000',
        errors: {}
    });

    useEffect(() => {
        const fetchVORLoggedBy = async () => {
            if (props.vORLoggedByID) {
                setLoading(true);
                try {
                    let res = await getVORLoggedBy(props.vORLoggedByID);
                    let data = res?.data?.table[0] || {};
                    if (res.success) {
                        setState((st) => ({
                            ...st,
                            vORLoggedByDescription: data.vorLoggedByDescription,
                            vORLoggedByBackgroundColour: data.vorLoggedByBackgroundColour || '#ffffff',
                            vORLoggedByTextColour: data.vorLoggedByTextColour || '#000000'
                        }));
                    }
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchVORLoggedBy();
    }, [props.vORLoggedByID]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((st) => ({
            ...st,
            [name]: value
        }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (!state.vORLoggedByDescription.trim()) {
            formIsValid = false;
            errors.vORLoggedByDescription = 'Description is required.';
        }

        setState((st) => ({
            ...st,
            errors: errors
        }));

        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setLoading(true);
            setBtnLoader(true);
            try {
                const data = {
                    vORLoggedByID: props.vORLoggedByID || null,
                    vORLoggedByDescription: state.vORLoggedByDescription,
                    vORLoggedByBackgroundColour: state.vORLoggedByBackgroundColour,
                    vORLoggedByTextColour: state.vORLoggedByTextColour
                };
                let res = await postVORLoggedBy(data);
                if (res.data.success) {
                    toastState?.showToastSuccess?.(`VOR Logged By Color ${props.vORLoggedByID ? 'Updated' : 'Added'} successfully`);
                    props.onClose(true);
                } else {
                    console.error(res.message);
                }
            } catch (error) {
                console.error('Error submitting data:', error);
            } finally {
                setLoading(false);
                setBtnLoader(false);
            }
        }
    };

    return (
        <div>
            {loading ? (
                <div style={{ margin: '325px 270px' }}>
                    <CircularProgress />
                    <Typography style={{ fontWeight: 'bold' }}>Loading...</Typography>
                </div>
            ) : (
                <Grid container direction="row" spacing={2} justify="center" alignItems="center">
                    <Grid item xs={12} className="mandatory-fields">
                        <MandatoryField
                            inputLabel="Description"
                            name="vORLoggedByDescription"
                            placeholder="Description"
                            onChange={handleInput}
                            value={state.vORLoggedByDescription}
                            errors={state.errors.vORLoggedByDescription}
                            autoFocus={true}
                        />
                    </Grid>
                    <Grid container spacing={2} style={{ marginLeft: -10, marginRight: 10 }}>
                        <Grid item xs={12} sm={6} style={{ textAlign: 'center', padding: 20 }}>
                            <FormLabel style={{ textAlign: 'center', padding: 10 }}>
                                <b>Text Colour</b>
                            </FormLabel>
                            <SketchPicker
                                color={state.vORLoggedByTextColour}
                                onChange={(color) => setState((st) => ({ ...st, vORLoggedByTextColour: color.hex }))}
                                width="100%"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ textAlign: 'center', padding: 20 }}>
                            <FormLabel style={{ textAlign: 'center', padding: 10 }}>
                                <b>Background Colour</b>
                            </FormLabel>
                            <SketchPicker
                                color={state.vORLoggedByBackgroundColour}
                                onChange={(color) => setState((st) => ({ ...st, vORLoggedByBackgroundColour: color.hex }))}
                                width="100%"
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="submit_btn">
                        <SecondaryButton isBtnLoader={btnLoader} onClick={handleSubmit}>
                            {props.vORLoggedByID ? 'Update' : 'Add'}
                        </SecondaryButton>
                    </Grid>
                </Grid>
            )}
        </div>
    );
}

export default VorLoggedByModal;
